import UnderConstruction from '../components/UnderConstruction'

const Credits = () => {
    return (
        <UnderConstruction/>
    );
}

export default Credits;